import { NavItemType } from './addStudent.type';

export const navItems: NavItemType[] = [
  {
    label: 'Academic',
    eventKey: 'academic',
    icon: 'book'
  },
  {
    label: 'Address',
    icon: 'map-pin',
    eventKey: 'address'
  }
];
